import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useBreadcrumbs } from '@connect-x-app/web-state';
import { toastError } from '@connect-x-app/web-ui';

import { useGetRole } from '../../queries';

export const useRole = () => {
  const { t } = useTranslation();
  const { roleId } = useParams();
  const updateBreadCrumbs = useBreadcrumbs(state => state.findAndReplace);
  const { data, isError, isLoading, isSuccess } = useGetRole(roleId ?? '');

  const updateBreadCrumbsName = useCallback(() => {
    if (isSuccess && data?.airlineRole) {
      updateBreadCrumbs(roleId, { name: data.airlineRole, url: `/admin/connect/roles/${roleId}` });
    }
  }, [data?.airlineRole, isSuccess, roleId, updateBreadCrumbs]);

  useEffect(() => {
    updateBreadCrumbsName();
  }, [updateBreadCrumbsName]);

  if (isError) {
    toastError(t('TOAST_ERROR'));
  }

  return { data, isError, isLoading, updateBreadCrumbsName };
};
